import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=5319ffb6&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
import style0 from "../../theme/avatar.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Avatar.vue?vue&type=style&index=1&id=5319ffb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319ffb6",
  null
  
)

export default component.exports